import { AccountId, ContractId } from "@hashgraph/sdk";
import { Button, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { ContractFunctionParameterBuilder } from "../services/wallets/contractFunctionParameterBuilder";
import { useWalletInterface } from "../services/wallets/useWalletInterface";
import SendIcon from '@mui/icons-material/Send';
import { useEffect, useState } from "react";
import { getTokenBalance, isAssociatedWithToken } from "../services/mirrorUtils";

export default function Home() {
  const { walletInterface, accountId } = useWalletInterface();
  const [loading, setLoading] = useState(false);
  const [isAssociated, setIsAssociated] = useState(false);
  const [contractHasBalance, setContractHasBalance] = useState(false);
  const [success, setSuccess] = useState(false);

  const tokenId = "0.0.9155750";
  const contractId = "0.0.9252620";

  const checkStatus = async () => {
    if (!accountId) return;

    setLoading(true);
    try {
      const balance = await getTokenBalance(contractId, tokenId);
      setContractHasBalance(balance > 0); // Treat under 91 as "out of tokens"

      if (balance > 0) {
        const associated = await isAssociatedWithToken(accountId.toString(), tokenId);
        setIsAssociated(associated);
      }
    } catch (err) {
      console.error("Error checking contract/token status", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkStatus();
  }, [accountId]);

  const handleCallContract = async () => {
    if (!walletInterface) return;

    const params = new ContractFunctionParameterBuilder(); // No parameters
    const gasLimit = 50_000;

    try {
      const txId = await walletInterface.executeContractFunction(
        ContractId.fromString(contractId),
        "getTdoubloons",
        params,
        gasLimit
      );
      console.log("Transaction submitted:", txId?.toString());
      setSuccess(true);
    } catch (err) {
      console.error("Contract call failed:", err);
    }
  };

  return (
    <Stack alignItems="center" spacing={4} p={4} maxWidth={600} mx="auto">
      <Typography variant="h4" color="white" align="center">
        Tdoubloons Faucet
      </Typography>

      {!accountId ? (
        <Typography color="white">
          To use this faucet, you need to:
          <ol style={{ marginTop: "0.5rem", marginBottom: "0.5rem", textAlign: "left" }}>
            <li>Be associated with Tdoubloons (<code>{tokenId}</code>).</li>
            <li>Connect your wallet through the button above.</li>
            <li>Click to call the faucet contract (<code>{contractId}</code>).</li>
          </ol>
          You should receive 1 Tdoubloon, and your transaction fees should be around $0.0035 in HBAR.
          <br /><br />
          By using this faucet you signify your agreement to our{" "}
          <a href="https://tozm.io/?page=terms" target="_blank" rel="noopener noreferrer" style={{ color: "#90caf9" }}>
            Terms
          </a>.
        </Typography>
      ) : (
        <>
          {success ? (
            <>
              <Typography color="white">
                Success! Check your wallet for a shiny new Tdoubloon.
          <br /><br />
          Go play some{" "}
          <a href="https://tozm.io/?page=maze" target="_blank" rel="noopener noreferrer" style={{ color: "#90caf9" }}>
            Tmazing
          </a>!
              </Typography>
              <Stack direction="row" spacing={2} mt={2}>

                <Button
          variant='contained'
          sx={{
            ml: "auto"
          }}
                  onClick={() => {
                    setSuccess(false);
                    checkStatus();
                  }}
                >
                  Back to Faucet
                </Button>
              </Stack>
            </>
          ) : loading ? (
            <Typography color="white">Checking status...</Typography>
          ) : !contractHasBalance ? (
            <Typography color="error">Faucet contract has no Tdoubloons to give.</Typography>
          ) : !isAssociated ? (
            <Typography color="error">
              You must be associated with Tdoubloons ({tokenId}) to use the Faucet.
            </Typography>
          ) : (
            <>
              <Stack direction="row" gap={2} alignItems="center">
                <Typography color="white">Call Faucet Contract</Typography>
                <Button variant="contained" onClick={handleCallContract}>
                  <SendIcon />
                </Button>
              </Stack>
              <Typography variant="body2" color="white" textAlign="center" mt={4}>
                By calling this faucet contract ({contractId}) you should receive 1 Tdoubloon,
                and your transaction fees should be around $0.0035 in HBAR.
                <br /><br />
                By using this faucet you signify your agreement to our{" "}
                <a href="https://tozm.io/?page=terms" target="_blank" rel="noopener noreferrer" style={{ color: "#90caf9" }}>
                  Terms
                </a>.
              </Typography>
            </>
          )}
        </>
      )}
    </Stack>
  );
}
